module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.data !== null) ? _c('div', {
    staticClass: "content-transition"
  }, [_c('btn-status-confirmar', {
    ref: "confirmarStatus",
    attrs: {
      "Status": _vm.getStatus
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fade-in-down"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('h4', {
    staticClass: "m-n font-thin h4"
  }, [_vm._v("Evento Cod.: #" + _vm._s(_vm.data.codigo))]), _vm._v(" "), _c('h1', {
    staticClass: "m-n font-thin h3"
  }, [_vm._v(_vm._s(_vm.data.titulo))]), _vm._v(" "), _c('span', {
    staticClass: "label no-radius bg-dark"
  }), _vm._v(" "), _c('span', {
    staticClass: "label m-l-n-xxs no-radius bg-success"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "visible-xs m-t-lg"
  }), _vm._v(" "), _c('u-button', {
    staticClass: "btn btn-sm btn-info pull-right pull-none-xs hidden-print",
    attrs: {
      "tabindex": "1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.print($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print m-r-xs"
  }), _vm._v(" Imprimir\n            ")]), _vm._v(" "), _c('u-button', {
    staticClass: "btn btn-sm btn-default pull-right pull-none-xs m-r-sm hidden-print",
    attrs: {
      "tabindex": "1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.editar($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit m-r-xs"
  }), _vm._v(" Editar\n            ")]), _vm._v(" "), _c('btn-status', {
    staticClass: "pull-right pull-none-xs m-r-sm hidden-print",
    attrs: {
      "Status": _vm.getStatus,
      "value": _vm.data.status
    },
    on: {
      "input": _vm.confirmarAlteracaoStatus
    }
  }), _vm._v(" "), _c('u-button', {
    staticClass: "btn btn-sm btn-default btn-danger pull-right pull-none-xs m-r-sm hidden-print",
    attrs: {
      "tabindex": "1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deletar($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit m-r-xs"
  }), _vm._v(" Deletar\n            ")]), _vm._v(" "), _c('router-link', {
    staticClass: "pull-right pull-none-xs hidden-print m-t-xs m-r",
    staticStyle: {
      "clear": "left"
    },
    attrs: {
      "to": {
        name: 'eventos'
      }
    }
  }, [_c('strong', {
    staticClass: "label no-radius bg-info"
  }, [_vm._v("Voltar")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('p', [_vm._v("\n              ID: "), _c('strong', [_vm._v(_vm._s(_vm.data.id))]), _vm._v(" "), _c('br'), _vm._v("\n              Data do cadastro: "), _c('strong', [_vm._v(_vm._s(_vm.moment(_vm.data.dateAdded.date).fromNow()))]), _vm._v(" "), _c('br'), _vm._v("\n              Título: "), _c('strong', [_vm._v(_vm._s(_vm.data.titulo))]), _c('br')]), _vm._v(" "), (_vm.data.observacao) ? _c('p', [_c('strong', [_vm._v("Observações")]), _c('br'), _c('br'), _vm._v("\n              " + _vm._s(_vm.data.observacao) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 text-right"
  }), _vm._v(" "), (_vm.data.descricao) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('strong', [_vm._v("Descrição do evento")]), _c('br'), _c('br'), _vm._v("\n            " + _vm._s(_vm.data.descricao) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "m-b m-t-lg"
  }, [_vm._v("Fotos")]), _vm._v(" "), _c('div', {
    staticClass: "fotos-flex"
  }, [_vm._l((_vm.data.fotos), function(foto, index) {
    return _c('div', {
      staticClass: "foto",
      attrs: {
        "id": 'ltFoto' + foto.id
      }
    }, [_c('a', {
      attrs: {
        "href": foto.url,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": foto.urlMin
      }
    })]), _vm._v(" "), (foto.destaque) ? _c('span', {
      staticClass: "destaque"
    }, [_vm._v("Destaque")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "btn-actions"
    }, [_c('u-button', {
      staticClass: "btn btn-xs btn-block btn-success",
      on: {
        "click": function($event) {
          return _vm.defineFotoDestaque(foto.id, index)
        }
      }
    }, [(!foto.atualizandoDestaque) ? _c('span', [_vm._v("Tornar Destaque")]) : _vm._e(), _vm._v(" "), (foto.atualizandoDestaque) ? _c('span', [_vm._v("Trabalhando nisso...")]) : _vm._e()]), _vm._v(" "), _c('u-button', {
      staticClass: "btn btn-xs btn-block btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeFoto(foto.id)
        }
      }
    }, [_vm._v("Remover")])], 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "foto"
  }, [(_vm.isUploadingFoto.length < 1) ? _c('u-button', {
    staticClass: "btn btn-info fileContainer hidden-print"
  }, [_c('i', {
    staticClass: "fa fa-upload m-r-sm"
  }), _vm._v(" Adicionar nova foto "), _c('input', {
    attrs: {
      "multiple": "",
      "accept": "image/*",
      "type": "file"
    },
    on: {
      "change": _vm.uploadFoto
    }
  })]) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.isUploadingFoto), function(foto1) {
    return _c('div', {
      staticClass: "foto"
    }, [_c('div', {
      staticClass: "text-center",
      staticStyle: {
        "display": "inline-flex",
        "width": "200px",
        "height": "200px",
        "align-content": "center",
        "align-items": "center"
      }
    }, [_c('div', {
      staticStyle: {
        "display": "block"
      }
    }, [_c('i', {
      staticClass: "fa fa-spin fa-spinner"
    }), _vm._v(" "), _c('div', [_vm._v("Enviando foto")])])])])
  })], 2)])])])])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc77b0a4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/eventos/components/Visualizar.vue
// module id = 1880
// module chunks = 17